import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, Thumbnail } from 'ionic-angular';
import { Content } from 'ionic-angular';
import { ConstsProvider } from '../../../providers/retirement-tools/consts/consts'
import * as jsPDF from 'jspdf'
import { HomePage } from '../../home/home';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { ProfileviewPage } from '../../profileview/profileview';
import moment from "moment";

interface Users {
  avatar: string,
  is_admin: boolean,
  order: number,
  id: string
}

@IonicPage()
@Component({
  selector: 'page-retirement-calculator',
  templateUrl: 'retirement-calculator.html',
})
export class RetirementCalculatorPage {
  ////////
  user_name = '';
  user_img: any;
  usersCollection: AngularFirestoreCollection<Users>;
  userId: string;
  users: Users[];
  ////
  arreglo1;
  arreglo2;
  arreglo3;
  ////
  @ViewChild(Content) content: Content;
  ////
  dataStep1: any;
  dataStep2: any;
  dataStep3: any;
  dataStep4: any;
  dataStep5: any;
  ////
  isStep1: boolean = true;
  isStep2: boolean = false;
  isStep3: boolean = false;
  isStep4: boolean = false;
  isStep5: boolean = false;
  isStep6: boolean = false;
  //Gastos chart
  public doughnutChartLabels1: string[] = ['Necesario', 'Estilo de vida', 'Adicional'];
  public doughnutChartData1: number[] = [0, 0, 0];
  _doughnutChartData1: number[] = [0, 0, 0];
  public doughnutChartLabels2: string[] = ['Necesario', 'Estilo de vida', 'Adicional'];
  public doughnutChartData2: number[] = [0, 0, 0];
  _doughnutChartData2: number[] = [0, 0, 0];
  public doughnutChartType: string = 'doughnut';
  public dougnutChartcolors: Array<any> = [
    {
      backgroundColor: ['#007AA9', '#463685', '#59D7B5', '#f53d3d']
    }
  ];
  chart1: boolean = false;
  chart2: boolean = false;
  ////
  public barChartType: string = 'bar';
  //Ingresos Chart
  _doughnutChartData3: number[] = [0, 0, 0, 0];
  public doughnutChartLabels3: string[] = ['Seguro social', 'Empresa', 'Ahorro personal', 'Otras inversiones'];
  public doughnutChartData3: number[] = [0, 0, 0, 0];
  ////Objetivo Chart
  _doughnutChartData4: number[] = [0, 0, 0, 0];
  public doughnutChartLabels4: string[] = ['Pensiones', 'Otros ingresos', 'Extra'];
  public doughnutChartData4: number[] = [0, 0, 0];
  public doughnutChartOptions4 = {
    rotation: 1 * Math.PI,
    circumference: 1 * Math.PI
  }
  //////Balance Financiero
  public barChartLabels: string[] = ['Ingresos'];
  public barChartLegend: boolean = true;
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartData: number[] = [0, 0];
  _barChartData: number[] = [0, 0];
  //Mi objetivo de ingresos
  public pieChartLabels: string[] = ['Pensión extra', 'Otros ingresos', 'Ahorro personal', 'Pensión empresa', 'Pensión IMSS'];
  public pieChartData: number[] = [0, 0, 0, 0, 0, 0];
  public pieChartType: string = 'doughnut';
  _pieChartData: number[] = [0, 0, 0, 0];
  //Supuestos
  supuestos1 = {
    nombre: '',
    ocupation: 'gerente',
    edadJubilacion: 0,
    edadIngreso: 0,
    edadActual: 0,
    antiguedad: 0,
    miEsperanzaDeVida: 0,
    esperanzaDeVidaGeneral: 0,
    semanasCotizadas: 0,
    anosCotiz: 0,
    anoImss: "1995-06",
    regimenJubilatorioImss: 1973,
    sueldoMensual: 0,
    sueldoIntegrado: 0,
    sueldoDiario: 0,
    factorInteg: 0,
    ingresoNeto: 0,
    planJubilacion: false,
    planEquivaleEnIL: 0,
    ahorrasParaJubilarte: false,
    ahorroIndividual: 0,
    //saldoInicial: 0,
    saldoInicialPlanAnterior: 0,
    anosAhorrando: 0,
    otrasInversiones: 0,
    matchDeLaEmpresa: 0.5,
    maximoEmpresa: 0.25
  }
  //Supuestos Generales
  incSalario = { nominales: 0.04, reales: 0 };
  tasaInteres = { nominales: 0.06, reales: 0 };
  incSalarioMin = { nominales: 0.04, reales: 0 };
  inflacion = { nominales: 0.04, reales: 0 };
  tasaEsperanzaVida: number = 0.035;
  umaDiaria: number = 89.62;
  //Supuestos IMSS
  salarioMaximoCotizacion: number;
  cuotaIMSS: number = 0.065;
  ajustePension73: number = 1.11;
  factSp5anos: number;
  asignFamIMSS: number = 0.15;
  indiceRendNeto: number;
  saldoInicial: number;
  integracionIl = {
    aguinaldo: { mensual: 30, anual: 0 },
    vacaciones: { mensual: 0, anual: 0 },
    pmaVacacional: { mensual: 0.25, anual: 0 },
    fondoAhorro: { anual: 0.13, mensual: 0.25 },
    vales: { mensual: 0, anual: 0.1 },
    bono: { mensual: 0, anual: 0 },
    total: 0,
    porcentaje: 0
  }
  //Validación
  validation = {
    edadJubilacion: { col1: 55, col2: 70 },
    edadIngreso: { col1: 16, col2: 0 },
    edadActual: { col1: 16, col2: 95 },
    antiguedad: { col1: 0, col2: 0 },
    miEsperanzaDeVida: { col1: 0, col2: 110, },
    esperanzaDeVidaGeneral: { col1: 0, col2: 110 },
    semanasCotizadas: 0,
    anoImss: { col1: 0, col2: 0 },
    sueldoMensual: { col1: 0, col2: 0 },
    sueldoDiario: 0,
    factorInteg: { col1: 1, col2: 2 },
    ingresoNeto: { col1: 0, col2: 1000000 },
    planJubilacion: 0,
    planEquivaleEnIL: { col1: 0, col2: 5 },
    ahorrasParaJubilarte: { col1: true, col2: false },
    ahorroIndividual: { col1: 0, col2: 10 },
    anosAhorrando: { col1: 0, col2: 0 },
    limiteMininoSueldo: 0
  };
  //Supuestos Anualidad
  anualidad = {
    planAhorro: 0,
    miEsperanza: 0,
    esperanzaGeneral: 0,
    anualidadPerpetuidad: 0,
    sobreEleccionPersonal: 0
  }
  //Resumenes de gatos
  resumenGastosHoy = {
    fijo: 0,
    variable: 0,
    adicional: 0,
    total: 0
  }
  resumenGastosJub = {
    fijo: 0,
    variable: 0,
    adicional: 0,
    total: 0
  }
  //pensiones
  pensiones = {
    imms: {
      val: 0,
      type: 0,
      factor: 1
    },
    empresa: {
      val: 0,
      factor: 0
    },
    miAhorro: {
      val: 0,
      factor: 0
    },
    inversiones: 0,
    adicional: 0,
    sueldo: 0
  }
  //imss73
  imss73;
  //imss97
  imss97;
  //Plan
  plan;
  /////
  anualidadPlanAhorro: number;
  /////
  pensionesJubilacionSubTotal: number = 0;
  pensionesJubilacionTotal: number = 0;
  ///OBJETIVO A LA JUBILACION
  objetivo = {
    ingresosProyectados: 0,
    gatosEstimados: 0,
    deficitSuperHabit: 0,
    deseoUnIngresoTotal: 0,
    pensionExtra: 0,
    capitalRequerido: 0,
    edadQueVivire: 0
  }
  //////Mi ahorro
  miAhorro1 = {
    capital: 0,
    intereses: 0,
    total: 0,
    pension: 0,
    porcentajeSueldo: 0
  }
  miAhorro2 = {
    capital: 0,
    intereses: 0,
    total: 0,
    pension: 0,
    porcentajeSueldo: 0
  }
  miAhorro3 = {
    capital: 0,
    intereses: 0,
    total: 0,
    pension: 0,
    porcentajeSueldo: 0
  }
  
  ahorro = {
    mensual: 0,
    conservador: 0,
    moderada: 0,
    optimista: 0
  }
  public gastos = [
    { label: 'Alimentación en casa (súper, abarrotes y productos de consumo)', type: 'Necesario', value: { today: 20000, retirement: 20000 }, otherExpense: false }
  ];
  public ingresos = {
    inversiones: 0,
    otras: 0
  }

  private ocupation: string = "";
  isAdmin: boolean;
  fullName: string;

  constructor(private fire: AngularFirestore, private FireAuth: AngularFireAuth, public navCtrl: NavController, public navParams: NavParams, public Const: ConstsProvider, private alertController: AlertController, public modalCtrl: ModalController) {

    this.presentConfirm();
  }

  logout() {
    this.FireAuth.auth.signOut().then(() => { });
  }

  profile() {
    let modal = this.modalCtrl.create(ProfileviewPage);
    modal.present({ ev: event });
  }

  ionViewWillEnter() {
    this.FireAuth.auth.onAuthStateChanged(data => {
      if (data && data.uid) {
        this.userId = data.uid;
        this.fire.doc("Users/" + data.uid).snapshotChanges().subscribe(document => {
          if (document.payload.exists) {
            this.user_name = document.payload.data() && document.payload.data().name ? document.payload.data().name : '';
            this.user_img = document.payload.data() && document.payload.data().profile && document.payload.data().profile.downloadURL ? document.payload.data().profile.downloadURL : '';
            this.ocupation = document.payload.data() && document.payload.data().ocupation ? document.payload.data().ocupation : 'director';
            const name = document.payload.data() && document.payload.data().name ? document.payload.data().name : '';
            const lastName = document.payload.data() && document.payload.data().lastName ? document.payload.data().lastName : '';
            this.fullName = name + " " + lastName;
            this.isAdmin = (document.payload.data() && document.payload.data().type == 1) ? true : false;
            this.content.resize();
          }
        });
      }
    });
  }

  presentConfirm() {
    let alert = this.alertController.create({
      title: 'Aviso',
      message: 'Este ejercicio tiene fines didácticos y está basado en cálculos aproximados y estimaciones que no deben considerarse como exactos, o con validez oficial. Para proteger tu privacidad y tus datos, la información que ingreses en este ejercicio no se guardará. El acceso a esta herramienta es exclusivo del usuario y no debe ser compartido.',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            this.navCtrl.setRoot(HomePage);
          }
        },
        {
          text: 'Aceptar'
        }
      ]
    });
    alert.present();
  }

  ionViewDidEnter() {
    this.timer();
    this.usersCollection = this.fire.collection('users', ref => ref.orderBy("order", 'desc'));
    this.usersCollection.snapshotChanges().subscribe(data => {
      this.users = data.map(item => {
        return {
          avatar: item.payload.doc.data().avatar,
          is_admin: item.payload.doc.data().is_admin,
          order: item.payload.doc.data().order,
          id: item.payload.doc.id
        }
      })
    });
  }

  timer() {
    setTimeout(() => {
      this.chart1 = true;
      this.refresh1();
      this.refresh2();
    }, 2000);
  }

  assignDataRt(event) {
    this.initData(event);
  }

  pdf() {
    var doc = new jsPDF({
      orientation: 'landscape',
      unit: 'in',
      format: [4, 2]
    })

    doc.text('Hello world!', 1, 1)
    doc.save('two-by-four.pdf')
  }

  initData(event) {
    //////////Supuestos IMSS////////
    this.salarioMaximoCotizacion = 25 * this.umaDiaria * 30;
    ////////////Supuestos
    this.supuestos1.nombre = event && event.name ? event.name : 'Mi nombre';
    this.supuestos1.ocupation = event && event.ocupation ? event.ocupation : 'gerente';
    this.supuestos1.edadJubilacion = Number(event && event.ageTarget ? event.ageTarget : 0);
    this.supuestos1.edadActual = Number(event && event.age ? event.age : 0);
    this.supuestos1.antiguedad = Number(event && event.seniority ? event.seniority : 0);
    this.supuestos1.edadIngreso = this.supuestos1.edadActual - this.supuestos1.antiguedad;
    this.supuestos1.esperanzaDeVidaGeneral = Math.round((this.searchInObjectArray(this.supuestos1.edadJubilacion, this.Const.esperanzaDeVida, 'edad') && this.searchInObjectArray(this.supuestos1.edadJubilacion, this.Const.esperanzaDeVida, 'edad').esperanzaH ? this.searchInObjectArray(this.supuestos1.edadJubilacion, this.Const.esperanzaDeVida, 'edad').esperanzaH : 0) + this.supuestos1.edadJubilacion);
    this.supuestos1.anoImss = event && event.immssEntry ? event.immssEntry : "1995-06";
    this.supuestos1.semanasCotizadas = (Number(new Date().getFullYear()) - moment(this.supuestos1.anoImss).year()) * 52;
    this.supuestos1.anosCotiz = this.supuestos1.semanasCotizadas / 52;
    this.supuestos1.regimenJubilatorioImss = moment(this.supuestos1.anoImss).valueOf() < moment("1997-07").valueOf() ? 1973 : 1997;
    this.supuestos1.sueldoMensual = event.salaryGreaterThan ? (event.corporateRetirementPlan ? event.salaryToConsider : this.salarioMaximoCotizacion) : event.salary;
    this.supuestos1.sueldoIntegrado = event && event.integralSalary ? event.integralSalary : 0;
    ///////////Supuestos Generales////////
    this.incSalario.reales = Math.max(this.incSalario.nominales - this.inflacion.nominales, 0);
    this.tasaInteres.reales = Math.max(this.tasaInteres.nominales - this.inflacion.nominales, 0);
    this.incSalarioMin.reales = Math.max(this.incSalarioMin.nominales - this.inflacion.nominales, 0);
    this.inflacion.reales = Math.max(this.inflacion.nominales - this.inflacion.nominales, 0);
    ///////////Supuestos IMSS////////
    this.factSp5anos = ((1 - Math.pow((1 + this.inflacion.nominales), (-5))) / this.inflacion.nominales) / 5;
    this.indiceRendNeto = this.tasaInteres.reales + 0.005;
    this.saldoInicial = this.supuestos1.anosCotiz > 0 ? Math.min(this.supuestos1.sueldoMensual, 25 * this.umaDiaria * 30) * Math.min(this.supuestos1.anosCotiz, Number(new Date().getFullYear()) - 1997) : 0;
    ///////////Integración IL////////
    this.integracionIl.aguinaldo.anual = ((this.supuestos1.sueldoMensual / 30) * 30) / 12;
    this.integracionIl.vacaciones.mensual = this.searchInObjectArray(this.supuestos1.antiguedad, this.Const.vacacionesLft, 'antig') && this.searchInObjectArray(this.supuestos1.antiguedad, this.Const.vacacionesLft, 'antig').dias ? this.searchInObjectArray(this.supuestos1.antiguedad, this.Const.vacacionesLft, 'antig').dias : 0;
    this.integracionIl.vacaciones.anual = ((this.supuestos1.sueldoMensual / 30) * this.integracionIl.vacaciones.mensual) / 12;
    this.integracionIl.pmaVacacional.anual = this.integracionIl.vacaciones.anual * this.integracionIl.pmaVacacional.mensual;
    this.integracionIl.fondoAhorro.mensual = Math.min(this.integracionIl.fondoAhorro.anual * this.supuestos1.sueldoMensual, this.integracionIl.fondoAhorro.anual * 10 * this.umaDiaria * 30);
    this.integracionIl.vales.mensual = Math.min(this.integracionIl.vales.anual * this.supuestos1.sueldoMensual, this.umaDiaria * 30);
    this.integracionIl.bono.anual = ((this.integracionIl.bono.mensual / 30) * this.supuestos1.sueldoMensual) / 12;
    this.integracionIl.total = this.integracionIl.aguinaldo.anual + this.integracionIl.pmaVacacional.anual + this.integracionIl.fondoAhorro.mensual + this.integracionIl.vales.mensual + this.integracionIl.bono.anual;
    this.integracionIl.porcentaje = this.integracionIl.total / this.supuestos1.sueldoMensual;
    ////////////Supuestos
    this.supuestos1.factorInteg = this.supuestos1.sueldoIntegrado / this.supuestos1.sueldoMensual;
    this.supuestos1.sueldoDiario = this.supuestos1.sueldoIntegrado / 30;
    this.supuestos1.planJubilacion = event.corporateRetirementPlan;
    /////Validaciones
    this.validation.antiguedad.col2 = this.supuestos1.edadActual - 16;
    this.validation.edadIngreso.col2 = this.supuestos1.edadActual - this.validation.antiguedad.col2;
    this.validation.semanasCotizadas = this.supuestos1.antiguedad * 52;
    this.validation.anoImss.col1 = Number(new Date().getFullYear()) - (this.supuestos1.edadActual - this.validation.edadActual.col1);
    this.validation.anoImss.col2 = Number(new Date().getFullYear()) - this.supuestos1.antiguedad;
    this.validation.sueldoMensual.col1 = this.umaDiaria * 30;
    this.validation.sueldoMensual.col2 = this.salarioMaximoCotizacion;
    this.validation.sueldoDiario = this.umaDiaria;
    this.validation.ingresoNeto.col1 = this.validation.sueldoMensual.col1;
    this.validation.planJubilacion = this.supuestos1.planJubilacion ? 1 : 0;
    this.validation.anosAhorrando.col2 = this.supuestos1.antiguedad;
    this.validation.limiteMininoSueldo = event.salaryGreaterThan ? this.salarioMaximoCotizacion : event.salaryGreaterThan ? event.salaryToConsider : event.salary;
    this.validation.ahorroIndividual.col2 = event.ocupation === 'director' ? 10 : 5;
    ///this.validation.ahorroIndividual.col2 = 10;
    ////////////Supuestos
    this.supuestos1.planEquivaleEnIL = this.validation.planJubilacion == 0 ? 0 : event.compensationTimes;
    this.supuestos1.ahorrasParaJubilarte = event.retirementSaving;
    this.supuestos1.ahorroIndividual = this.supuestos1.ahorrasParaJubilarte ? (Number(event.monthlySavings)) / 100 : 0;
    this.supuestos1.anosAhorrando = event.yearsSaving;
    this.supuestos1.saldoInicialPlanAnterior = this.supuestos1.planJubilacion ? Number(event.initialBalanceDerivedFromThePreviousPlan) : 0;
    //////////////this.supuestos1.matchDeLaEmpresa = event.ocupation === 'director' ? 1 : 0.5;
    this.supuestos1.matchDeLaEmpresa = 1;
    this.supuestos1.maximoEmpresa = event.ocupation === 'director' ? 0.05 : 0.025;
    this.supuestos1.miEsperanzaDeVida = this.objetivo.edadQueVivire;
    //////////////
    this.anualidadPlanAhorro = this.searchInObjectArray(this.supuestos1.edadJubilacion, this.Const.esperanzaDeVida, 'edad') && this.searchInObjectArray(this.supuestos1.edadJubilacion, this.Const.esperanzaDeVida, 'edad').privada ? this.searchInObjectArray(this.supuestos1.edadJubilacion, this.Const.esperanzaDeVida, 'edad').privada : 0;
    //////////////
    this.imss73 = this.Const.imss73(this.supuestos1.edadActual, this.supuestos1.anosCotiz, this.supuestos1.sueldoMensual, this.incSalario.reales, this.supuestos1.factorInteg, this.umaDiaria, this.factSp5anos, this.asignFamIMSS, this.supuestos1.edadJubilacion, this.ajustePension73);
    this.arreglo1 = this.imss73.table;
    //////////////
    this.imss97 = this.Const.imss97(this.supuestos1.edadActual, this.supuestos1.anosCotiz, this.supuestos1.sueldoMensual, this.incSalario.reales, this.supuestos1.factorInteg, this.umaDiaria, this.supuestos1.edadJubilacion, this.cuotaIMSS, this.saldoInicial, this.indiceRendNeto, this.asignFamIMSS);
    this.arreglo2 = this.imss97.table;
    //////////////
    this.plan = this.Const.plan(this.supuestos1.edadActual, this.supuestos1.antiguedad, this.supuestos1.sueldoMensual, this.incSalario.reales, this.supuestos1.factorInteg, this.umaDiaria, this.supuestos1.edadJubilacion, this.supuestos1.ahorrasParaJubilarte, this.supuestos1.ahorroIndividual, this.supuestos1.saldoInicialPlanAnterior, this.tasaInteres.reales, this.supuestos1.planJubilacion, this.supuestos1.planEquivaleEnIL, event.salaryToConsider, this.integracionIl.porcentaje, this.supuestos1.matchDeLaEmpresa, this.supuestos1.sueldoIntegrado, this.supuestos1.maximoEmpresa);//,this.integracionIl.porcentaje);
    this.arreglo3 = this.plan.table;
    //////////////
    this._pensiones();
    // ////////////////ahorro
    this.dataStep1 = event;
    ///Todos los calculos
    this.allCalc();
  }

  _pensiones() {
    this.pensiones.imms.type = this.supuestos1.regimenJubilatorioImss == 1973 ? 73 : 97;
    this.pensiones.imms.factor = this.supuestos1.miEsperanzaDeVida == 0 || this.supuestos1.regimenJubilatorioImss == 1973 ? 1 : this.anualidad.planAhorro / this.anualidad.miEsperanza;
    this.pensiones.imms.val = moment(this.supuestos1.anoImss) <= moment("1997-07") ? (this.imss73.pension.definitiva / this.pensiones.imms.factor) : (this.imss97.pension.total / this.pensiones.imms.factor);
    this.pensiones.empresa.factor = this.supuestos1.miEsperanzaDeVida == 0 ? 1 : this.anualidad.planAhorro / this.anualidad.miEsperanza;
    this.pensiones.empresa.val = this.plan.pension.total * this.pensiones.empresa.factor;
    this.pensiones.miAhorro.factor = this.supuestos1.miEsperanzaDeVida == 0 ? 1 : this.anualidad.planAhorro / this.anualidad.miEsperanza;
  }

  allCalc() {
    this._pensiones();//Borrar si existe algun problema
    this.anualidadCalc();
    this.objetivoJubilacion();
    this.calcOtherInverstment();
    this.paintChart3();
    this.paintChart4();
    this.auto();
  }

  step1(event: any) {
    this.initData(event);
    this.isStep1 = false;
    this.isStep2 = true;
    this.content.scrollToTop();
  }

  step2(event: any) {
    this.dataStep2 = event.formValues;
    this.resumenGastosHoy.fijo = event.values.today.values[0];
    this.resumenGastosHoy.variable = event.values.today.values[1];
    this.resumenGastosHoy.adicional = event.values.today.values[2];
    this.resumenGastosHoy.total = event.values.today.total;
    this.resumenGastosJub.fijo = event.values.retirement.values[0];
    this.resumenGastosJub.variable = event.values.retirement.values[1];
    this.resumenGastosJub.adicional = event.values.retirement.values[2];
    this.resumenGastosJub.total = event.values.retirement.total;
    this.allCalc();
    this.isStep2 = false;
    this.isStep3 = true;
    this.isStep3 = false;
    this.isStep4 = true;
    this.content.scrollToTop();
  }

  step3(event: any) {
    this.dataStep3 = event;
    this.resumenGastosJub.fijo = event.chartData[0];
    this.resumenGastosJub.variable = event.chartData[1];
    this.resumenGastosJub.adicional = event.chartData[2];
    this.resumenGastosJub.total = this.resumenGastosJub.fijo + this.resumenGastosJub.variable + this.resumenGastosJub.adicional;
    this.allCalc();
    this.isStep3 = false;
    this.isStep4 = true;
    this.content.scrollToTop();
  }

  step4(event: any) {
    this.dataStep4 = event;
    this.allCalc();
    this.isStep4 = false;
    this.isStep5 = true;
    this.content.scrollToTop();
  }

  step5(event: any) {
    this.auto();
    this.dataStep5 = event;
    this.isStep5 = false;
    this.isStep6 = true;
    this.content.scrollToTop();
    this.paintChart5();
    this.paintChart6();
  }

  ahorroCaculate(x: number, type: string, anualidad: number, findObject?: boolean): any {
    const miAhorro1 = this.Const.ahorro(this.supuestos1.edadActual, this.supuestos1.antiguedad, this.supuestos1.sueldoMensual, this.incSalario.reales, this.supuestos1.edadJubilacion - 1, x, type).miAhorro;
    let miAhorro2;
    if (!findObject) {
      miAhorro2 = this.Const.ahorro(this.supuestos1.edadActual, this.supuestos1.antiguedad, this.supuestos1.sueldoMensual, this.incSalario.reales, this.supuestos1.edadJubilacion, x, type/*, this.supuestos1.otrasInversiones*/).miAhorro;
    }
    let _miAhorro1 = {
      capital: 0,
      intereses: 0,
      total: 0,
      pension: 0,
      porcentajeSueldo: 0
    }
    _miAhorro1.capital = miAhorro1.capital;
    _miAhorro1.intereses = miAhorro1.intereses;
    _miAhorro1.total = _miAhorro1.capital + _miAhorro1.intereses;
    _miAhorro1.pension = _miAhorro1.total / anualidad;
    if (!findObject) {
      _miAhorro1.porcentajeSueldo = _miAhorro1.pension / miAhorro2.sueldo;
    }
    return findObject ? _miAhorro1.pension : _miAhorro1;
  }

  ahorroCaculateIndividual(anualidad: number, findObject?: boolean): any {
    const individual = this.Const.individual(this.supuestos1.edadActual, this.supuestos1.antiguedad, this.supuestos1.sueldoMensual, this.incSalario.reales, this.supuestos1.edadJubilacion - 1, this.supuestos1.ahorroIndividual, this.tasaInteres.reales);
    const miAhorro1 = individual.miAhorro;
    let miAhorro2;
    if (!findObject) {
      miAhorro2 = this.Const.individual(this.supuestos1.edadActual, this.supuestos1.antiguedad, this.supuestos1.sueldoMensual, this.incSalario.reales, this.supuestos1.edadJubilacion, this.supuestos1.ahorroIndividual, this.tasaInteres.reales).miAhorro;
    }
    let _miAhorro1 = {
      capital: 0,
      intereses: 0,
      total: 0,
      pension: 0,
      porcentajeSueldo: 0
    }
    _miAhorro1.capital = miAhorro1.capital;
    _miAhorro1.intereses = miAhorro1.intereses;
    _miAhorro1.total = _miAhorro1.capital + _miAhorro1.intereses;
    _miAhorro1.pension = _miAhorro1.total / anualidad;
    if (!findObject) {
      _miAhorro1.porcentajeSueldo = _miAhorro1.pension / miAhorro2.sueldo;
    }
    return findObject ? _miAhorro1.pension : _miAhorro1;
  }

  anualidadCalc() {
    this.anualidad.planAhorro = this.searchInObjectArray(this.supuestos1.edadJubilacion, this.Const.esperanzaDeVida, 'edad') && this.searchInObjectArray(this.supuestos1.edadJubilacion, this.Const.esperanzaDeVida, 'edad').privada ? this.searchInObjectArray(this.supuestos1.edadJubilacion, this.Const.esperanzaDeVida, 'edad').privada : 0;
    this.anualidad.miEsperanza = ((1 - Math.pow((1 + this.tasaEsperanzaVida), -1 * Math.max(this.supuestos1.miEsperanzaDeVida - this.supuestos1.edadJubilacion, 0))) / this.tasaEsperanzaVida) * 12;
    this.anualidad.esperanzaGeneral = ((1 - Math.pow((1 + this.tasaEsperanzaVida), -1 * Math.max(this.supuestos1.esperanzaDeVidaGeneral - this.supuestos1.edadJubilacion, 0))) / this.tasaEsperanzaVida) * 12;
    this.anualidad.anualidadPerpetuidad = (1 / this.tasaEsperanzaVida) * 12;
    this.anualidad.sobreEleccionPersonal = Number(this.supuestos1.miEsperanzaDeVida) > 0 ? Number(this.anualidad.miEsperanza) : Number(this.anualidadPlanAhorro);
  }

  objetivoJubilacion() {
    this.objetivo.ingresosProyectados = Number(this.pensiones.imms.val) + Number(this.pensiones.empresa.val) + Number(this.pensiones.miAhorro.val) + Number(this.pensiones.inversiones);
    this.objetivo.gatosEstimados = this.resumenGastosJub.total;
    this.objetivo.deficitSuperHabit = this.objetivo.ingresosProyectados - this.objetivo.gatosEstimados;
    this.objetivo.pensionExtra = Math.max(this.objetivo.deseoUnIngresoTotal - this.objetivo.ingresosProyectados, 0);
    this.objetivo.capitalRequerido = this.objetivo.pensionExtra * this.anualidad.sobreEleccionPersonal;
  }

  calcOtherInverstment() {
    this.pensiones.inversiones = this.ingresos.inversiones / this.anualidad.sobreEleccionPersonal + this.ingresos.otras;
    this.pensionesJubilacionSubTotal = this.pensiones.imms.val + this.pensiones.empresa.val + this.pensiones.miAhorro.val;
    this.pensionesJubilacionTotal = this.pensiones.imms.val + this.pensiones.empresa.val + this.pensiones.miAhorro.val + this.pensiones.inversiones;
  }

  _otherInvestments(event) {
    this.ingresos = event;
    this.allCalc();
    this.paintChart3();
  }

  _iWantATotalIncome(event) {
    this.objetivo.deseoUnIngresoTotal = Number(event);
    this.allCalc();
    this.paintChart4();
  }

  _ageToLive(event) {
    this.supuestos1.miEsperanzaDeVida = Number(event);
    this.objetivo.edadQueVivire = this.supuestos1.miEsperanzaDeVida;
    this._iWantATotalIncome(this.objetivo.deseoUnIngresoTotal);
    this.allCalc();
    this.paintChart4();
  }

  back1() {
    this.isStep1 = true;
    this.isStep2 = false;
    this.content.scrollToTop();
  }

  back2() {
    this.isStep2 = true;
    this.isStep4 = false;
    this.content.scrollToTop();
  }

  back3() {
    this.isStep3 = true;
    this.isStep4 = false;
    this.content.scrollToTop();
  }

  back4() {
    this.isStep4 = true;
    this.isStep5 = false;
    this.content.scrollToTop();
  }

  back5() {
    this.isStep5 = true;
    this.isStep6 = false;
    this.content.scrollToTop();
  }

  refresh1() {
    this.doughnutChartData1 = this._doughnutChartData1;
  }

  refresh2() {
    this.doughnutChartData2 = this._doughnutChartData2;
  }

  refresh3() {
    this.doughnutChartData3 = this._doughnutChartData3;
  }

  refresh4() {
    this.doughnutChartData4 = this._doughnutChartData4;
  }

  refresh5() {
    this.barChartLabels[1] = this._barChartData[1] >= 0 ? 'Superávit' : 'Déficit';
    this.barChartData = this._barChartData;
  }

  refresh6() {
    this.pieChartData = this._pieChartData;
  }

  paintChart2(ev) {
    this._doughnutChartData2 = [0, 0, 0];
    this._doughnutChartData2[0] = ev.chartData[0];
    this._doughnutChartData2[1] = ev.chartData[1];
    this._doughnutChartData2[2] = ev.chartData[2];
    if (this.chart1 == true) {
      this.refresh2();
    }
  }

  paintChart3() {
    this._doughnutChartData3 = [0, 0, 0, 0];
    this._doughnutChartData3[0] = this.pensiones.imms.val;
    this._doughnutChartData3[1] = this.pensiones.empresa.val;
    this._doughnutChartData3[2] = this.pensiones.miAhorro.val;
    this._doughnutChartData3[3] = this.pensiones.inversiones;
    this.refresh3();
  }

  paintChart4() {
    this._doughnutChartData4 = [0, 0, 0];
    this._doughnutChartData4[0] = this.pensionesJubilacionSubTotal;
    this._doughnutChartData4[1] = this.pensiones.inversiones;
    this._doughnutChartData4[2] = this.objetivo.pensionExtra;
    this.refresh4();
  }

  paintChart5() {
    this._barChartData = [0, 0];
    this._barChartData[0] = this.objetivo.gatosEstimados + this.objetivo.deficitSuperHabit;
    this._barChartData[1] = this.objetivo.deficitSuperHabit;
    this.refresh5();
  }

  paintChart6() {
    this._pieChartData = [0, 0, 0, 0, 0];
    this._pieChartData[0] = this.objetivo.pensionExtra;
    this._pieChartData[1] = this.pensiones.inversiones;
    this._pieChartData[2] = this.pensiones.miAhorro.val;
    this._pieChartData[3] = this.pensiones.empresa.val;
    this._pieChartData[4] = this.pensiones.imms.val;
    this.refresh6();
  }

  auto() {
    const mensual = this.autoCallculate(this.objetivo.pensionExtra, 'base');
    const moderada = this.autoCallculate(this.objetivo.pensionExtra, 'medio');
    const optimista = this.autoCallculate(this.objetivo.pensionExtra, 'optimista');
    const individual = this.autoCallculateAhorro();
    this.pensiones.miAhorro.val = individual;
    this.ahorro.mensual = mensual.inicial;
    this.ahorro.conservador = mensual.inicial;
    this.ahorro.moderada = moderada.inicial;
    this.ahorro.optimista = optimista.inicial;
  }

  autoCallculate(objetivo: number, type: string): any {
    let resultado: number = 0;
    let inicial = 0.1;
    do {
      inicial = inicial * 10;
      resultado = this.ahorroCaculate(inicial, type, this.anualidad.sobreEleccionPersonal, true);
    } while (resultado < objetivo);
    let base = inicial;
    let size = inicial.toString().length + 3;
    let newInicial = 0;
    for (let i = 0; i < size; i++) {
      base = base / 10;
      do {
        newInicial = newInicial + base;
        resultado = this.ahorroCaculate(newInicial, type, this.anualidad.sobreEleccionPersonal, true);
      } while (resultado < objetivo);
      newInicial = newInicial - base;
    }
    return { "data": this.ahorroCaculate(newInicial, type, this.anualidad.sobreEleccionPersonal), "inicial": newInicial };
  }

  autoCallculateAhorro(): number {
    return this.ahorroCaculateIndividual(this.anualidad.sobreEleccionPersonal, true);
  }

  average(arreglo: number[]): number {
    let suma: number = 0
    arreglo.forEach(element => {
      suma += element;
    });
    return suma / arreglo.length;
  }

  searchInObjectArray(value: any, arreglo: any[], key: string): any {
    return arreglo[arreglo.map(element => { return element[key] }).indexOf(value)];
  }

  goToHome() {
    let alert = this.alertController.create({
      title: '¿Estás seguro de querer salir?',
      message: 'Al salir, perderás todos los datos guardados en la calculadora.',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Salir',
          handler: () => {
            this.navCtrl.pop();
          }
        }
      ]
    });
    alert.present();
  }

}


// WEBPACK FOOTER //
// ./src/pages/retirement-tools/retirement-calculator/retirement-calculator.ts